import { formatDateToDDMMYYYY } from "../../../utils/FormatUtils";

type Props = {
  selectedRow: any
};

const ThongTinChiTietPhieuXuat = (props: Props) => {
    const { selectedRow = {} } = props;
  return (
    <div className="bg-white position-relative spaces gap-6 spaces w-100 mb-6 fl-1">
      <div className="spaces w-100">
        <div className="border-bottom spaces px-10 pt-5 flex justify-content-between">
          <div></div>
          <div>
            <h4 className="text-title fw-bold text-end fs-4 spaces mb-0 line-height-24">
              {selectedRow.name
                ? selectedRow.name
                : 'Thông tin bệnh nhân'
              }
            </h4>
            <p className="text-end spaces mb-4">
              {selectedRow.patientAddress ? selectedRow.patientAddress : 'Địa chỉ: ...'}
            </p>
          </div>
        </div>
        <div className="spaces w-100 justify-content-center p-10">
          <div className="flex flex-wrap">
            <div className="flex spaces w-50">
              <span className="text-ellipsis-title fw-bold">
                Bác sĩ:
              </span>
              <span className="text-ellipsis-content">
                {selectedRow?.doctorName || '...'}
              </span>
            </div>
            <div className="flex spaces w-50">
              <span className="text-ellipsis-title fw-bold">
                Kho:
              </span>
              <span className="text-ellipsis-content">
                {selectedRow.mateWhName || '...'}
              </span>
            </div>
            <div className="flex spaces w-50">
              <span className="text-ellipsis-title fw-bold">
                Số bảo hiểm:
              </span>
              <span className="text-ellipsis-content">
                {selectedRow.cardNumberBhyt || '...'}
              </span>
            </div>
            <div className="flex spaces w-50">
              <span className="text-ellipsis-title fw-bold">
                Chẩn đoán:
              </span>
              <span className="text-ellipsis-content">
                {[selectedRow?.diagnosis, selectedRow?.comorbidity].filter(Boolean).join(', ') || '...'}
              </span>
            </div>
            <div className="flex spaces w-50">
              <span className="text-ellipsis-title fw-bold">
                Ngày y lệnh:
              </span>
              <span className="text-ellipsis-content">
                {selectedRow?.doCreation ? formatDateToDDMMYYYY(selectedRow?.doCreation) : '...'}
              </span>
            </div>
            <div className="flex spaces w-50">
              <span className="text-ellipsis-title fw-bold">
                ICD chính, phụ:
              </span>
              <span className="text-ellipsis-content">
                {[selectedRow?.diagnosisCode, selectedRow?.comorbidity].filter(Boolean).join(', ') || '...'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThongTinChiTietPhieuXuat;
